import AdditionalSwatchSelectionMenu from './AdditionalSwatchSelectionMenu';

export default AdditionalSwatchSelectionMenu;
